import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryCourierRecruit = async (params: object) => {
  return await GET({ url: Api.queryCourierRecruit, params, showError: false })
}
